import type {Intervention} from '@/ts/types/dto/interventions-dto';
import {
  inject,
  provide,
  ref,
  type Ref,
} from 'vue';
import {useLogger} from '@/ts/composables/pure/use-logger';

/** Injects the provided intervention ref from the ancestor component tree */
export function useInterventionStore(): Ref<Intervention | null> {
  const logger = useLogger();
  logger.trace('useInterventionStore')();
  return inject<Ref<Intervention | null>>('intervention')!;
}

/** Creates and provides a reactive intervention ref for descendant components to inject */
export function useCreateIntervention(intervention: Intervention | null, logId: string): Ref<Intervention | null> {
  const logger = useLogger();
  const reactiveIntervention = ref(intervention);
  provide('intervention', reactiveIntervention);
  logger.info(`useCreateIntervention ${logId} ${intervention?.id}`)();
  return reactiveIntervention;
}
